import React, { useContext } from "react";
import AppContext from "../context/Context";
import CondominiumRoutes from "../routes/CondominiumRoutes";

const CondominiumLayout = () => {
  const { isFluid } = useContext(AppContext);

  return (
    <div className={isFluid ? "container-fluid" : "container"}>
      <CondominiumRoutes />
    </div>
  );
};

export default CondominiumLayout;
